<template>
  <BaseControlBar>
  <!-- <BaseControlBar :back-url="backUrl"> -->
    <div class="flex-grow-1 d-flex">
      <h1>{{ title }}&nbsp;</h1>
      <StatusLabel :item="status"></StatusLabel>
    </div>
    <template v-if="!readOnly">
      <BaseButton variant="outline-secondary" @click="onCancel" class="app--mobile-hidden"
        >取消</BaseButton
      >
      <BaseButton @click="onSave" class="app--mobile-hidden">儲存</BaseButton>
    </template>
    <template v-else>
      <ButtonApprove
        v-if="isPermit('APPROVED')"
        :disabled="inputVal.reward.status === 'APPROVED'"
        @click="prepareAction('APPROVE', '你已批准這個優惠')"
        class="app--mobile-hidden"
        variant="primary"
      >
        {{ inputVal.reward.status === "PENDING" ? "批准" : "重新批准" }}
      </ButtonApprove>
      <ButtonReject
        v-if="isPermit('REJECTED')"
        :disabled="inputVal.reward.status === 'REJECTED'"
        @click="prepareAction('REJECT', '你已拒絕這個優惠')"
        class="app--mobile-hidden"
      >
        拒絕
      </ButtonReject>
      <ButtonUnpublish
        v-if="isPermit('STOPPED')"
        @click="prepareAction('UNPUBLISH', '你已暫停發佈這個優惠')"
        class="app--mobile-hidden"
      >
        暫停發佈
      </ButtonUnpublish>
      <ButtonEdit v-if="isPermit('EDIT')" @click="onEdit" class="app--mobile-hidden"
        >編輯</ButtonEdit
      >
      <ButtonRedemptionStatus
        v-if="isPermit('REDEMPTION_STATUS')"
        @click="stocksModal = true"
        class="app--mobile-hidden"
      >
        兌換情況
      </ButtonRedemptionStatus>
      <ButtonPreview
        @click="$bvModal.show('coupon-preview-modal')"
        variant="outline-secondary"
        class="app--mobile-hidden"
      >
        預覽
      </ButtonPreview>
      <ButtonRemove
        v-if="isPermit('REMOVED')"
        @click="prepareAction('REMOVE', '你已移除這個優惠')"
        class="app--mobile-hidden"
      >
        移除
      </ButtonRemove>
    </template>

    <template v-slot:secondRow>
      <!-- button-for-mobile start -->
      <template v-if="!readOnly">
        <div class="coupon-overview-wrapper app--hidden app--mobile-shown">
          <div class="overview-wrapper">
            <div class="overview">
              <div class="right">
                <BaseButton variant="none" @click="onCancel" class="mobile-btn">取消</BaseButton>
              </div>
            </div>
            <div class="overview">
              <div class="right">
                <BaseButton @click="onSave" class="mobile-btn" variant="none">儲存</BaseButton>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="coupon-overview-wrapper app--hidden app--mobile-shown">
          <div class="overview-wrapper">
            <div class="overview" v-if="isPermit('APPROVED')">
              <div class="right">
                <ButtonApprove
                  :disabled="inputVal.reward.status === 'APPROVED'"
                  @click="prepareAction('APPROVE', '你已批准這個優惠')"
                  variant="none"
                  class="mobile-btn mobile-btn-green"
                >
                  {{ inputVal.reward.status === "PENDING" ? "批准" : "重新批准" }}
                </ButtonApprove>
              </div>
            </div>

            <div class="overview" v-if="isPermit('REJECTED')">
              <div class="right">
                <ButtonReject
                  :disabled="inputVal.reward.status === 'REJECTED'"
                  @click="prepareAction('REJECT', '你已拒絕這個優惠')"
                  class="mobile-btn mobile-btn-red"
                >
                  拒絕
                </ButtonReject>
              </div>
            </div>

            <div class="overview" v-if="isPermit('STOPPED')">
              <div class="right">
                <ButtonUnpublish
                  @click="prepareAction('UNPUBLISH', '你已暫停發佈這個優惠')"
                  variant="none"
                  class="mobile-btn mobile-btn-red"
                >
                  暫停發佈
                </ButtonUnpublish>
              </div>
            </div>

            <div class="overview" v-if="isPermit('EDIT')">
              <div class="right">
                <ButtonEdit @click="onEdit" variant="none" class="mobile-btn mobile-btn-blue"
                  >編輯</ButtonEdit
                >
              </div>
            </div>

            <div class="overview" v-if="isPermit('REDEMPTION_STATUS')">
              <div class="right">
                <ButtonRedemptionStatus
                  @click="stocksModal = true"
                  variant="none"
                  class="mobile-btn"
                >
                  兌換情況
                </ButtonRedemptionStatus>
              </div>
            </div>

            <div class="overview">
              <div class="right">
                <ButtonPreview
                  @click="$bvModal.show('coupon-preview-modal')"
                  variant="none"
                  class="mobile-btn"
                >
                  預覽
                </ButtonPreview>
              </div>
            </div>

            <div class="overview" v-if="isPermit('REMOVED')">
              <div class="right">
                <ButtonRemove
                  @click="prepareAction('REMOVE', '你已移除這個優惠')"
                  variant="none"
                  class="mobile-btn"
                >
                  移除
                </ButtonRemove>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- button-for-mobile start -->
    </template>

    <AdminActionConfirmModal
      v-model="approval"
      :onCouponStatusUpdate="onCouponStatusUpdate$"
      :loading="loading"
    ></AdminActionConfirmModal>
    <CouponStocksModal
      v-model="stocksModal"
      :id="inputVal.reward.id"
      :isShowStockQuantity="true"
    ></CouponStocksModal>
    <ActionSuccessModal v-model="actionSuccessModal"></ActionSuccessModal>
  </BaseControlBar>
</template>

<script>
import { tap, switchMap } from 'rxjs/operators';

import controlBarMixin from '@/mixins/control-bar';

import BaseControlBar from '@/components/BaseControlBar.vue';
import ButtonApprove from '@/components/button/ButtonApprove.vue';
import ButtonReject from '@/components/button/ButtonReject.vue';
import ButtonUnpublish from '@/components/button/ButtonUnpublish.vue';
import AdminActionConfirmModal from '@/components/coupon/AdminActionConfirmModal.vue';
import ActionSuccessModal from '@/components/ActionSuccessModal.vue';
import http from '../../helpers/http';

export default {
  mixins: [controlBarMixin],
  components: {
    BaseControlBar,
    AdminActionConfirmModal,
    ActionSuccessModal,
    ButtonApprove,
    ButtonReject,
    ButtonUnpublish,
  },
  props: {
    validate: {
      type: Function,
    },
  },
  data: () => ({
    approval: {
      modal: false,
      action: null,
      remarks: null,
      doNotSendEmail: false,
    },
    loading: false,
    stocksModal: false,
    actionSuccessModal: {
      show: false,
      action: null,
      msg: null,
      back: {
        location: '/admin/coupons',
        text: '返回優惠列表',
      },
    },
    availableActions: {
      PENDING: ['APPROVED', 'REJECTED', 'EDIT', 'PREVIEW', 'REMOVED'],
      SCHEDULED: ['EDIT', 'PREVIEW', 'REMOVED', 'STOPPED'],
      PUBLISHED: ['EDIT', 'STOPPED', 'REDEMPTION_STATUS'],
      STOPPED: ['APPROVED', 'EDIT', 'PREVIEW', 'REMOVED', 'REDEMPTION_STATUS'],
      EXPIRED: ['EDIT', 'PREVIEW', 'REMOVED', 'REDEMPTION_STATUS'],
      REJECTED: ['APPROVED', 'EDIT', 'PREVIEW', 'REMOVED'],
      REMOVED: ['PREVIEW'],
    },
  }),
  computed: {
    backUrl() {
      return this.$route.name === 'EditCoupon' ? '/admin/coupons' : '/admin/paidCoupons';
    },
  },
  domStreams: ['onCouponStatusUpdate$'],
  subscriptions() {
    return {
      couponStatusUpdate: this.onCouponStatusUpdate$.pipe(
        tap(() => {
          this.loading = true;
        }),
        switchMap(() => {
          const { action, remarks, msg } = this.approval;
          return http(
            {
              method: 'POST',
              url: `/agc-admin-api/coupons/${action.toLowerCase()}`,
              data: {
                rewardId: this.inputVal.reward.id,
                remarks,
                isSendEmail: !this.approval.doNotSendEmail,
              },
            },
            {
              next: (res) => {
                this.inputVal = res;
                if (msg) {
                  this.actionSuccessModal = {
                    ...this.actionSuccessModal,
                    show: true,
                    action,
                    msg,
                    back: {
                      location: this.backUrl,
                      text: '返回優惠列表',
                    },
                  };
                }
              },
              complete: () => {
                this.approval.modal = false;
                this.loading = false;
                this.approval.doNotSendEmail = false;
              },
            },
          );
        }),
      ),
    };
  },
  methods: {
    async prepareAction(action, msg) {
      if (action === 'APPROVE') {
        const isValid = await this.validate();
        if (!isValid) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
      }
      this.approval = {
        modal: true,
        action,
        remarks: null,
        msg,
        doNotSendEmail: this.approval.doNotSendEmail,
      };
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .approval-modal {
  &__header {
    border-bottom: none;
  }
}

@include respond(tab-landscape) {
  .app--mobile-shown {
    display: block !important;
  }

  .app--mobile-hidden {
    display: none !important;
  }

  .mobile-btn-grey {
    color: gray !important;
  }

  .mobile-btn-blue {
    color: #3596f4 !important;
  }

  .mobile-btn-green {
    color: green !important;
  }

  .mobile-btn-red {
    color: red !important;
  }
}

.coupon-overview-wrapper {
  background-color: #fff;
  width: 100%;
  display: inline-block;
  color: #fff;
  position: relative;
  margin-bottom: 10px;

  .overview-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .overview {
      width: 100%;
      color: #000;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;

      .left {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-content: space-between;
      }
      .right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #ccc;
      }
    }

    .overview:last-child {
      .right {
        border: 0px;
      }
    }
  }
}

@include respond(tab-landscape) {
  .mobile-btn {
    flex-direction: column;
    background: none;
    border: none;
    color: gray;
  }
}
</style>
